<div class="container">
    <div class="section">
        <mat-card class="mat-elevation-z0">
            <mat-card-header>
                <mat-card-title>{{'model.step1.title' | translate}}</mat-card-title>
                <mat-card-subtitle>
                    <!-- <img style="float: left;" height="100px" src="assets/images/Genio_pose_1-2.png"> -->
                    <p>{{ 'model.step1.' + this.labeledDataManager.modelType | translate }}</p>
                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-actions *ngIf="labeledDataManager.modelType == 'numerical'" class="action-centered">
                <mat-form-field  class="full-width">
                    <input name="dimension" [disabled]="labeledDataManager.featureDimensionLocked" [(ngModel)]="labeledDataManager.featureDimension" matInput placeholder="{{'test-model.feature-dimension' | translate}}"
                        value="">
                </mat-form-field>
            </mat-card-actions>
            
            
            <mat-card-actions *ngIf="labeledDataManager.modelType != 'numerical' || (labeledDataManager.modelType == 'numerical' && labeledDataManager.featureDimension > 0)" class="action-centered">
                <button (click)="addLabel()" matTooltip="{{'model.step1.hint'  | translate}}" mat-raised-button>
                    <mat-icon>add_circle</mat-icon> {{'model.addLabel.' + this.labeledDataManager.modelType |
                    translate}}
                </button>
            </mat-card-actions>
        </mat-card>


        <div *ngIf="loading" style="justify-content: center;">
            <p>{{'model.loadingdata' | translate}}</p>
            <img class="center" width="250px" [src]="'assets/images/loading.gif'" alt="loading">
        </div>

        <app-ml-label-container *ngFor="let label of labeledDataManager.labels" (onChildDeleted)="onDeleted($event)"
            [label]="label" [items]="labeledDataManager.labelsWithData.get(label)"></app-ml-label-container>
    </div>

    <div class="section">
        <mat-card class="mat-elevation-z0">
            <mat-card-header>
                <mat-card-title>{{'model.step2.title' | translate}}</mat-card-title>
                <mat-card-subtitle>
                    <!-- <img style="float: left;" height="100px" src="assets/images/Genio_Maquina-1-1.jpg"> -->
                    <p>{{ 'model.step2.' + this.labeledDataManager.modelType | translate }}</p>
                </mat-card-subtitle>
            </mat-card-header>

            <div *ngIf="labeledDataManager.advanced">
                <mat-card-actions class="action-centered">

                    <mat-form-field style="width: 80%;">
                        <mat-label>{{ 'model.choose_algorithm' | translate}}</mat-label>
                        <select (change)="onInputChange($event)" [(ngModel)]="mlAlgorithm" name="select"
                            matNativeControl>
                            <!-- <option value="naive-bayes" selected>{{ 'model.algorithm_naive-bayes' | translate}}</option> -->
                            <option value="neural-network">{{ 'model.algorithm_neural_network' | translate}}</option>
                            <option value="knn">{{ 'model.algorithm_knn' | translate}}</option>

                        </select>
                    </mat-form-field>

                </mat-card-actions>

                

                <mat-card-actions *ngIf="mlAlgorithm=='knn'" class="action-centered">
                    <mat-label>{{ 'model.knn.number_of_neighbors' | translate }}</mat-label>
                    <mat-slider thumbLabel (input)="onInputChange($event)" [(ngModel)]="labeledDataManager.algorithms_params.knn.k" min="1" max="30"
                        step="1"></mat-slider>
                    <mat-label>{{labeledDataManager.algorithms_params.knn.k}}</mat-label>
                </mat-card-actions>

                <mat-card-actions *ngIf="mlAlgorithm=='neural-network'" class="action-centered">
                    <mat-label>{{ 'model.neural-network.epochs' | translate }}</mat-label>
                    <mat-slider thumbLabel (input)="onInputChange($event)" [(ngModel)]="labeledDataManager.algorithms_params.neural_network.epochs"
                        min="1" max="50" step="1"></mat-slider>
                    <mat-label>{{labeledDataManager.algorithms_params.neural_network.epochs}}</mat-label>
                    <br>
                    <mat-label>{{ 'model.neural-network.batchSize' | translate }}</mat-label>
                    <mat-slider thumbLabel (input)="onInputChange($event)" [(ngModel)]="labeledDataManager.algorithms_params.neural_network.batchSize"
                        min="1" max="100" step="1"></mat-slider>
                    <mat-label>{{labeledDataManager.algorithms_params.neural_network.batchSize}}</mat-label>
                    <br>
                    <mat-label>{{ 'model.neural-network.learningRate' | translate }}</mat-label>
                    <mat-slider thumbLabel (input)="onInputChange($event)"
                        [(ngModel)]="labeledDataManager.algorithms_params.neural_network.learningRate" min="0.0001" max="1" step="0.0001">
                    </mat-slider>
                    <mat-label>{{labeledDataManager.algorithms_params.neural_network.learningRate}}</mat-label>

                </mat-card-actions>
                <mat-card-actions class="action-centered">
                    <mat-label>{{ 'model.neural-network.validationSplit' | translate }}</mat-label>
                    <mat-slider thumbLabel (input)="onInputChange($event)" [(ngModel)]="labeledDataManager.algorithms_params.validationSplit" min="0"
                        max="100" step="1"></mat-slider>
                    <mat-label>{{labeledDataManager.algorithms_params.validationSplit}}</mat-label>
                </mat-card-actions>
            </div>


            <mat-card-actions class="action-centered">
                <button *ngIf="this.labeledDataManager.modelType == 'image' || this.labeledDataManager.modelType == 'numerical'"
                    matTooltip="{{ 'model.step2.hint.' + this.labeledDataManager.modelType | translate }}"
                    (click)="train()" mat-raised-button>
                    <mat-icon>build</mat-icon> {{ 'model.button.learn.' + this.labeledDataManager.modelType | translate
                    }}
                </button>

                <div *ngIf="this.labeledDataManager.modelType == 'text'">
                    <mat-label>{{ 'model.choose_language' | translate}} </mat-label>
                    <select [(ngModel)]="language" name="select">
                        <option value="es" selected>Español</option>
                        <option value="gl">Galego</option>
                        <option value="en">English</option>
                        <option value="ca">Català</option>
                        <option value="eu">Euskera</option>
                        <option value="it">Italiano</option>
                        <option value="de">Deutsch</option>
                        <option value="de">Ελληνικά</option>
                        <option value="pt">Português</option>

                    </select>
                    <br />
                    <button style="margin: 20px;"
                        matTooltip="{{ 'model.step2.hint.' + this.labeledDataManager.modelType | translate }}"
                        (click)="train()" mat-raised-button>
                        <mat-icon>build</mat-icon> {{ 'model.button.learn.' + this.labeledDataManager.modelType |
                        translate }}
                    </button>
                </div>

            </mat-card-actions>
        </mat-card>

        <plotly-plot *ngIf="graphConfusionMatrix && labeledDataManager.advanced" [data]="graphConfusionMatrix.data" [layout]="graphConfusionMatrix.layout"></plotly-plot>

        <plotly-plot *ngIf="graphHistory && labeledDataManager.advanced" [data]="graphHistory.data" [layout]="graphHistory.layout"></plotly-plot>
        
        <plotly-plot *ngIf="graphContour && labeledDataManager.advanced" [data]="graphContour.data" [layout]="graphContour.layout"></plotly-plot>

    </div>



    <div class="section">
        <app-ml-test-text-model *ngIf="labeledDataManager.modelType=='text'"></app-ml-test-text-model>
        <app-ml-test-image-model *ngIf="labeledDataManager.modelType=='image'"></app-ml-test-image-model>
        <app-ml-test-numerical-model *ngIf="labeledDataManager.modelType=='numerical'"></app-ml-test-numerical-model>

    </div>
</div>